import {Pipe, PipeTransform} from '@angular/core';
import {ICruiseDetailCabin} from '../../cruise-detail-page/interfaces/icruise-detail-cabin';
import {IShipServiceRemote} from '../../cruise-detail-page/interfaces/iship-service-remote';

@Pipe({
  name: 'allCabinImagesByType'
})
export class AllCabinImagesByTypePipe implements PipeTransform {

  private static getRandomRoomImage(): string[] {
    return [`assets/images/rooms/room-${Math.round(Math.random() * 9)}.jpg`];
  }

  transform(value: ICruiseDetailCabin, shipService: IShipServiceRemote): string[] {
    // se ho passato il dettaglio cabina e lo shipService ...
    if (value && shipService) {
      // recupero la cabina con type specifico
      const cabin = shipService.cabins?.find((cab) => cab.category.toLowerCase() === value.type.toLowerCase());

      // ritorno un array con i percorsi delle immagini della cabina, se non presenti, utilizzo di default un immagine placeholder random
      if (cabin?.images?.length > 0) {
        return cabin.images.map((image) => (image.image_path) ? image.image_path : AllCabinImagesByTypePipe.getRandomRoomImage()[0]);
      }
    }

    // utilizzo di default un immagine placeholder random
    return AllCabinImagesByTypePipe.getRandomRoomImage();
  }

}
